import { render } from "./WaveIcon.vue?vue&type=template&id=2b01d1c0"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/WaveIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b01d1c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b01d1c0', __exports__)) {
    api.reload('2b01d1c0', __exports__)
  }
  
  module.hot.accept("./WaveIcon.vue?vue&type=template&id=2b01d1c0", () => {
    api.rerender('2b01d1c0', render)
  })

}


export default __exports__